import React from 'react';
import { locations } from '../../mock';
import { Phone, MapPin, Mail, Clock } from 'lucide-react';

export const LocationsSection = () => {
  return (
    <section id="locations" className="section section-alt" data-testid="locations-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: 'var(--sage-dark)' }}>Our Locations</h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Conveniently serving Saginaw and Frankenmuth with two accessible locations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {locations.map((location) => (
            <div key={location.id} className="location-card" data-testid={`location-card-${location.id}`}>
              <div className="mb-6 rounded-lg overflow-hidden">
                <img
                  src={location.image}
                  alt={`${location.name} Building`}
                  className="w-full h-64 object-cover"
                />
              </div>

              <h3 className="text-2xl font-bold mb-6" style={{ color: 'var(--sage-dark)' }}>{location.name}</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.address + ', ' + location.city + ', ' + location.state + ' ' + location.zip)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start space-x-3 hover:opacity-70 transition-opacity"
                    data-testid={`location-map-link-${location.id}`}
                  >
                    <MapPin className="w-6 h-6 mt-1 flex-shrink-0" style={{ color: 'var(--earth-accent)' }} />
                    <div>
                      <p className="text-gray-700 font-medium">{location.address}</p>
                      <p className="text-gray-700">{location.city}, {location.state} {location.zip}</p>
                    </div>
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone className="w-6 h-6 flex-shrink-0" style={{ color: 'var(--earth-accent)' }} />
                  <a
                    href={`tel:${location.phone.replace(/\D/g, '')}`}
                    className="text-lg font-semibold hover:underline"
                    style={{ color: 'var(--earth-accent)' }}
                    data-testid={`location-phone-${location.id}`}
                  >
                    {location.phone}
                  </a>
                </div>
                {location.fax && (
                  <div className="flex items-center space-x-3">
                    <Phone className="w-6 h-6 flex-shrink-0 text-gray-600" />
                    <span className="text-gray-700">Fax: {location.fax}</span>
                  </div>
                )}
                <div className="flex items-center space-x-3">
                  <Mail className="w-6 h-6 flex-shrink-0" style={{ color: 'var(--earth-accent)' }} />
                  <a href={`mailto:${location.email}`} className="text-gray-700 hover:underline break-all">
                    {location.email}
                  </a>
                </div>
                <div className="flex items-start space-x-3 pt-4 border-t border-gray-200">
                  <Clock className="w-6 h-6 text-gray-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="text-gray-700 font-medium">Office Hours</p>
                    <p className="text-gray-600">Monday - Thursday: 8:00 AM - 4:00 PM</p>
                    <p className="text-gray-600">Friday: 8:00 AM - 11:00 AM</p>
                    <p className="text-gray-600 mt-1">After Hours: (989) 583-2362</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
